import { EmojiRepository } from '@atlaskit/emoji/resource';
import { denormaliseEmojiServiceResponse } from '@atlaskit/emoji/utils';
import type {
  EmojiProvider,
  EmojiServiceResponse
} from '@atlaskit/emoji/types';

import { SandboxEmojiResource } from './sandbox-emoji-resource';
import { SandboxEmojiResourceConfig } from './types';
import { getEmojis } from './get-emojis';

type DataFetch = () => Promise<EmojiServiceResponse>;

export const getEmojiProvider = async function getEmojiProvider(
  config?: SandboxEmojiResourceConfig,
  fn: DataFetch = () => Promise.resolve(getEmojis())
): Promise<EmojiProvider> {
  const response = await fn();
  const { emojis } = denormaliseEmojiServiceResponse(response);
  const repository = new EmojiRepository(emojis);
  return new SandboxEmojiResource(repository, config);
};
